<template>
    <div>
        <template v-if="parentLabel">
            <h4 v-if="isShop" class="external-activity--name">{{ parentLabel }}</h4>
            <h4 v-else class="external-activity--name" style="justify-content: flex-start; margin-left: 20px;">{{ parentLabel }}</h4>
        </template>
        <template v-else>
            <h4 class="external-activity--name">{{ defaultCartLanguage.heading_level_1 }}, {{ localUser.guest_name }}, <br>{{ defaultCartLanguage.heading_level_2 }}</h4>
            <p style="margin-bottom: 10px" class="text-center">{{ defaultCartLanguage.sub_heading }}</p>
        </template>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    export default {
        props: [
            'isShop',
            'localUser',
            'parentLabel'
        ],

        computed: {
            ...mapGetters(['defaultCartLanguage']),
        }
    }
</script>
